import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { PlyrComponent } from 'ngx-plyr';

@Component({
  selector: 'lifedi-most-least-choice',
  templateUrl: './most-least-choice.component.html',
  styleUrls: ['./most-least-choice.component.scss']
})
export class MostLeastChoiceComponent implements OnInit {

  @Input() mostLeastData;
  @Input() measureForm: FormGroup;
  @Input() isAutoNumber: boolean = true;
  @Input() questionNumber: number;
  @Input() type: string;
  @Input() font: string;
  @Output() progressVal = new EventEmitter<Number>();

  @ViewChild(PlyrComponent)

  choice1;
  choice2;
  formMostLeastChoice;

  plyr: PlyrComponent;
  player: Plyr;

  videoSources: Plyr.Source[] = [];
  videoBtnStatus: boolean = true;
  audioBtnStatus: boolean = true;
  time_again: number;
  vdoCurrentTime;
  unlimit: boolean;
  audCurrentTime: number = 0;

  countProgress: number = 1;
  countAnswers: number = 0;
  done: boolean = false;

  constructor(
    private fb: FormBuilder
  ) { }

  get answers(): FormArray {
    if (this.measureForm) {
      return this.measureForm.controls['DATA'] as FormArray;
    }
  }

  ngOnInit(): void {
    this.time_again = this.mostLeastData.VALUE[0].media.time_again ? parseInt(this.mostLeastData.VALUE[0].media.time_again) : 0;
    this.unlimit = this.mostLeastData.VALUE[0].media.unlimit ? true : false;

    if (this.mostLeastData.VALUE[0].media.file_url) {
      this.videoSources.push({
        src: this.mostLeastData.VALUE[0].media.vdo_id,
        provider: 'vimeo',
      })
    }

    if (this.type === 'measure') {
      this.formMostLeastChoice = this.fb.group({
        ID: [this.mostLeastData.ID, Validators.required],
        ANSWER: this.fb.group({
          MOSTCHOICE: ['', Validators.required],
          LEASTCHOICE: ['', Validators.required]
        })
      });
      this.answers.push(this.formMostLeastChoice);
    } else if (this.type === 'research') {
      this.formMostLeastChoice = this.fb.group({
        ID: [this.mostLeastData.ID, Validators.required],
        ANSWER: this.fb.group({
          MOSTCHOICE: [''],
          LEASTCHOICE: ['']
        })
      });
      this.answers.push(this.formMostLeastChoice);
    } else {
      this.done = true;
    }

  }


  mostChoice(most) {
    if (most === this.choice2) {
      this.choice2 = '';
      this.formMostLeastChoice.controls['ANSWER'].patchValue({
        LEASTCHOICE: this.choice2
      })
    }
    this.formMostLeastChoice.controls['ANSWER'].patchValue({
      MOSTCHOICE: most
    })
    this.progress(this.formMostLeastChoice);
  }

  leastChoice(least) {
    if (least === this.choice1) {
      this.choice1 = '';
      this.formMostLeastChoice.controls['ANSWER'].patchValue({
        MOSTCHOICE: this.choice1
      })
    }
    this.formMostLeastChoice.controls['ANSWER'].patchValue({
      LEASTCHOICE: least
    })
    this.progress(this.formMostLeastChoice);

  }

  most2(most) {
    if (most === this.choice2) {
      this.choice2 = '';
    }
  }

  least2(least) {
    if (least === this.choice1) {
      this.choice1 = '';
    }
  }

  playAudio(au, loop) {
    let audioPlayer = <HTMLVideoElement>document.getElementById(au);
    audioPlayer.play();
    this.audioBtnStatus = false;

    this.time_again = this.time_again - 1;

  }


  playVideo(): void {
    this.player.play();
    this.videoBtnStatus = false;
    this.time_again = this.time_again - 1;
  }

  vdoEnable(loop): void {
    if (loop === 0) {
      this.videoBtnStatus = false;
    } else {
      this.videoBtnStatus = true;
    }
  }

  auEnable(loop): void {
    if (loop === 0) {
      this.audioBtnStatus = false;
    } else {
      this.audioBtnStatus = true;
    }
  }

  currentvdoTime() {
    this.vdoCurrentTime = this.player.currentTime / 100;
  }

  currentaudTime(au) {
    var audio = <HTMLVideoElement>document.getElementById(au);
    this.audCurrentTime = audio.currentTime / 100;
  }

  progress(form) {

    if (form.status === 'VALID') {
      this.done = true;
    } else if (form.status === 'INVALID') {
      this.done = false;
    }

    if (form.status === 'VALID' && this.countAnswers === 0) {
      this.countAnswers = 1;

      if (this.countAnswers === 1) {
        this.countProgress = 2;
        this.progressVal.emit(this.countProgress);
      }

    } else if (form.status === 'INVALID' && this.countProgress === 2) {
      this.countProgress = 0;
      this.countAnswers = 0;
      this.progressVal.emit(this.countProgress);
    }
  }

}
